"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingCircle = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var LoadingCircle_styles_1 = require("./LoadingCircle.styles");
var LoadingCircle = function () { return (react_1.default.createElement(LoadingCircle_styles_1.StyledSvg, { "data-testid": "loadingCircleSvg", className: "circle__svg", viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("circle", { className: "circle__svg-circle", cx: "50", cy: "50", r: "45" }))); };
exports.LoadingCircle = LoadingCircle;
//# sourceMappingURL=LoadingCircle.js.map